import { ColumnDef } from "@tanstack/react-table";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { formatDateTimeWithZone, formatRelativeDate } from "@/core/utils/date";
import { CustomerWithReferralsAndPayouts } from "@/customer/customer";

export const ReferredCol = (): ColumnDef<CustomerWithReferralsAndPayouts> => ({
  header: "Referred",
  accessorKey: "created_at",
  cell: ({ row }) => {
    const createdAt = row.original.created_at;
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{formatRelativeDate(createdAt)}</span>
        </TooltipTrigger>
        <TooltipContent>{formatDateTimeWithZone(createdAt)}</TooltipContent>
      </Tooltip>
    );
  },
});
